(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["colour-group-swatches"] && !Shopify.designMode) return;
  try {
    class ColourGroupSwatches extends HTMLElement {
    connectedCallback() {
      this.updateLinks();

      if (this.hasAttribute('data-collapse')) {
        var showMore = this.querySelector('[data-toggle="show-more"]');
        var hideMore = this.querySelector('[data-toggle="hide-more"]');

        if (showMore) {
          showMore.addEventListener('click', () => {
            this.setAttribute('data-expanded', '');
            showMore.setAttribute('aria-expanded', 'true');
          });
        }
        if (hideMore) {
          hideMore.addEventListener('click', () => {
            this.removeAttribute('data-expanded');
            showMore.setAttribute('aria-expanded', 'false');
          });
        }
      }
    }

    updateLinks() {
      var currentPath = window.location.pathname;
      var search = window.location.search;
      var links = this.querySelectorAll('a[data-handle]');

      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var handle = link.dataset.handle;
        var newPath = currentPath.replace(
          /\/products\/[^/?#]+/,
          '/products/' + handle
        );
        link.href = newPath + search;
      }
    }
  }

  if (!customElements.get('colour-group-swatches')) {
    customElements.define('colour-group-swatches', ColourGroupSwatches);
  }
  } catch(e) { console.error(e); }
})();

})();
